(() => {
  document.addEventListener('click', (e) => {
    if (!window.swinger.user.isLoggedIn()) {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e).closest('[data-like]');

    if (!elem) {
      return;
    }

    window.swinger.audioHapticFeedback.trigger('press');

    e.preventDefault();
    e.stopImmediatePropagation();
  });
})();
